import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.OrganizationInfo {
    padding: 0;

    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spacing(4)};

    & > * {
      height: fit-content;
    }

    .OrgVirtualCardsEnablePanel {
      grid-column: 2;
    }
  }
`
